module.exports = __webpack_public_path__ + "static/media/icon.ffa403df.svg";